import React from 'react';

const ValuePropositionSection: React.FC = () => {
  return (
    <section className="bg-[#1A2A44] py-16 mx-auto px-4 md:px-10 lg:px-32 xl:px-64 w-full pt-10 pb-10">
      <div className="">
        <div className="text-justify">
          <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#fff] leading-[26px] font-[400] mb-4 last:mb-0">
            Guided by Rob Bruggeman, a seasoned Bay Street analyst, engineer and CFA charterholder with a proven 100x success at AbraSilver, our community equips you with{' '}
            <strong>sophisticated strategies to master the high-stakes junior mining landscape.</strong>{' '}
            Whether targeting junior mining stocks focused on gold, silver, uranium, or copper, we deliver the insight needed to{' '}
            <strong>identify the best mining stocks and pursue 5x, 10x, or even 100x opportunities.</strong>{' '}
            <a 
              href="https://the-wealthy-miner.mn.co/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#D3A12A] hover:text-[#B8941F] transition-colors duration-300 underline"
            >
              <strong>Join us</strong>
            </a>{' '}
            to unlock elite mining investment strategies.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;
